export { default as socialAccounts } from './socialAccounts';

export const brand = 'THE OUTNET';
